<nav class="navbar navbar-expand headerContainer">
  <a class="navbar-brand d-flex" routerLink="/dashboard">
    @if (!logoData) {
      <img
        alt=""
        src="../../../assets/images/5_image.jpg"
        style="width: 50px; padding: 0px 5px"
      />
    }
    @if (logoData) {
      <img
        id="company-logo-picture"
        class="company-logo-picture-class"
        [src]="logo"
        alt=""
        id=""
      />
    }
    <div class="logoTxt">
      @switch (selectedApp) {
        @case ("contract") {
          <strong>Contract AI</strong>
          @if (caption) {
            <span>{{ caption }} <b class="version-2"></b></span>
          }
        }
        @case ("rfpcontract") {
          <strong>RFP</strong>
          @if (title) {
            <span>{{ title }} <b class="version-2"></b></span>
          }
        }
        @case ("infosecurity") {
          <strong>Information Security</strong>
          @if (caption) {
            <span>{{ caption }} <b class="version-2"></b></span>
          }
        }
        @case ("document") {
          <strong>Document Analytics</strong>
          @if (caption) {
            <span>{{ caption }} <b class="version-2"></b></span>
          }
        }
        @case ("email") {
          <strong>Email Analytics</strong>
          @if (caption) {
            <span>{{ caption }} <b class="version-2"></b></span>
          }
        }
        @default {
          @if (title) {
            <strong>{{ title }}</strong>
          }
          @if (!title) {
            <span>Canstring AI <b class="version-2"></b></span>
          }
          @if (caption) {
            <span>{{ caption }} <b class="version-2"></b></span>
          }
        }
      }
    </div>
  </a>
  <div class="collapse navbar-collapse" id="navbarScroll">
    <ul
      class="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll"
      style="--bs-scroll-height: 100px; margin-right: 15px"
    >
      <a
        class="nav-link dropdown-toggle"
        href="#"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        pTooltip="Apps"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 16 16"
        >
          <g fill="currentColor">
            <rect width="4" height="4" x="1" y="1" rx="1" ry="1" />
            <rect width="4" height="4" x="1" y="6" rx="1" ry="1" />
            <rect width="4" height="4" x="1" y="11" rx="1" ry="1" />
            <rect width="4" height="4" x="6" y="11" rx="1" ry="1" />
            <rect width="4" height="4" x="6" y="6" rx="1" ry="1" />
            <rect width="4" height="4" x="11" y="6" rx="1" ry="1" />
            <rect width="4" height="4" x="11" y="11" rx="1" ry="1" />
            <rect width="4" height="4" x="6" y="1" rx="1" ry="1" />
            <rect width="4" height="4" x="11" y="1" rx="1" ry="1" />
          </g>
        </svg>
      </a>
      <ul class="dropdown-menu app-box">
        <div class="row">
          <div class="col">
            <div
              class="apps-header-text text-center d-flex justify-content-center"
            >
              AI Analytics, Summarization, and Process Automation
            </div>
          </div>
        </div>
        <div class="row">
          @for (apps of appsList; track apps) {
            @if (apps?.active) {
              <div class="col-4 mb-3">
                <div
                  class="card"
                  (click)="selectedApps(apps)"
                  (keydown.enter)="selectedApps(apps)"
                >
                  <div class="tile-wrapper">
                    <div class="icon-wrapper">
                      <i class="{{ apps.icon }} apps-icon"></i>
                    </div>
                    <div class="p tile-name">{{ apps.text }}</div>
                  </div>
                </div>
              </div>
            }
          }
        </div>
        <div class="row">
          @for (apps of appsListNormal; track apps) {
            <div class="col-4 mb-3">
              @if (apps?.active) {
                <div
                  class="card"
                  (click)="selectedApps(apps)"
                  (keydown.enter)="selectedApps(apps)"
                >
                  <div class="tile-wrapper">
                    <div class="icon-wrapper">
                      <i class="{{ apps.icon }} apps-icon"></i>
                    </div>
                    <div class="p tile-name">{{ apps.text }}</div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </ul>
    </ul>
  </div>
</nav>
